<template>
	<div v-if="form.trade_data.length" class="accordion sticky-top" id="fixed-income-request">
		<div v-if="error" class="alert alert-warning alert-dismissible fade show shadow-sm" :style="'width: -webkit-fill-available'" role="alert">
			<div v-html="error"></div>
			<button type="button" class="close" data-dismiss="alert" aria-label="Close">
				<span aria-hidden="true">×</span>
			</button>
		</div>

		<form @submit.prevent="validateFixedIncomeRequest" class="card shadow-sm mg-b-40">
			<div class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
				<div>
					<h6 class="mg-b-5">
						<button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseFixedIncomeRequest" aria-expanded="true" aria-controls="collapseFixedIncomeRequest">
							Fixed Income Transaction Request
						</button>
					</h6>
					<p class="tx-13 tx-color-03 mg-b-0">0.01% is charged in statutory fees for secondary market transactions.</p>
				</div>
			</div>
			<div id="collapseFixedIncomeRequest" class="collapse show" data-parent="#fixed-income-request">
				<div class="card-body fixed-income-request pd-y-30">
					<div class="table-responsive">
						<table class="table table-dashboard mg-b-0" aria-describedby="fixed-income-request-table">
							<thead>
								<tr>
									<th scope="col" class="tx-medium text-center">Type</th>
									<th scope="col" class="tx-medium text-center">ISIN</th>
									<th scope="col">Description</th>
									<th scope="col">Volume</th>
									<th scope="col">ReInvestment</th>
									<th scope="col" class="tx-medium text-center"></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(request, index) in form.trade_data" :key="index">
									<td>
										<select
											v-model="request.type"
											class="form-control form-control-sm shadow-sm"
											:class="{ 'is-invalid': form.errors.has(`trade_data.${index}.type`) }"
											style="width: auto"
										>
											<option selected :value="null" disabled>Select an option</option>
											<option v-for="(option, index) in tradeTypes" :disabled="option.value !== 'BUY' ? !request.fixed_income.holding : false" :value="option.value" :key="index">
												{{ option.name | toStartCase }}
											</option>
										</select>
									</td>
									<td class="tx-color-03 tx-medium text-center">{{ request.fixed_income.security_isin }}</td>
									<td class="tx-color-03 tx-medium">{{ request.fixed_income.security_details.description }}</td>
									<td>
										<div class="form-group mb-0">
											<input
												type="number"
												step="any"
												v-model="request.volume"
												:min="request.fixed_income.min_trade_amount"
												class="form-control form-control-sm shadow-sm"
												:class="{ 'is-invalid': form.errors.has(`trade_data.${index}.volume`) }"
												placeholder="Enter amount"
												required
												style="width: auto"
											/>
											<has-error :form="form" :field="`trade_data.${index}.volume`"></has-error>
										</div>
									</td>
									<td>
										<div class="form-group mb-0" :class="{ 'd-none': request.type === 'SELL' }">
											<select
												v-model="request.maturity"
												class="form-control form-control-sm shadow-sm"
												:class="{ 'is-invalid': form.errors.has(`trade_data.${index}.maturity`) }"
												:disabled="request.type === 'SELL'"
												:required="request.type === 'BUY'"
											>
												<option selected :value="null" disabled>Select an option</option>
												<option v-for="(option, index) in maturityTypes" :value="option" :key="index">{{ option | toStartCase }}</option>
											</select>
											<has-error :form="form" :field="`trade_data.${index}.maturity`"></has-error>
										</div>
										<span :class="{ 'd-none': request.type === 'BUY' }">{{ '' | placeholder }}</span>
									</td>
									<td class="tx-medium text-center">
										<button type="button" class="btn btn-sm btn-danger shadow-sm" @click="removeFixedIncome(request.security_isin, index)">Remove</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="card-footer d-flex justify-content-end">
				<button-component :busy="form.busy" :label="'Proceed'" :label-loading="'Please Wait...'" :button-class="'btn btn-default shadow-sm mr-1'"></button-component>
				<button type="button" class="btn btn-primary shadow-sm ml-1" @click="removeAll">Cancel</button>
			</div>
		</form>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	data() {
		return {
			error: null,
		};
	},
	computed: {
		...mapGetters({
			maturityTypes: 'trade/maturityTypes',
			tradeTypes: 'trade/tradeTypes',
		}),
	},
	methods: {
		removeFixedIncome(isin, index) {
			this.$emit('remove-fixed-income', { isin, index });
		},
		removeAll() {
			this.$emit('remove-all');
		},
		validateFixedIncomeRequest() {
			this.$emit('validate-request');
		},
	},
	props: {
		form: {
			required: true,
		},
	},
};
</script>

<style scoped>
select {
	width: auto !important;
}
</style>